import { useEffect, useState } from 'react';
import useDelete from '../hook/useDelete';

const DeletePopup = () => {
    const { deletePopup, setDeletePopup, data }: any = useDelete();
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    useEffect(() => {
        if (deletePopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [deletePopup]);

    const closeModal = () => setDeletePopup(false);

    const deleteTheModal = () => {
        if (!isProcessing) {
            setIsProcessing(true);
            data?.isDelete(() => {
                setIsProcessing(false);
                closeModal();
            });
        }
    }

    return (
        <div
            className={`fixed inset-0 mt-11 p-4 z-[1000000568900] ${deletePopup ? "flex" : "hidden"
                } items-center justify-center before:fixed before:inset-0 before:bg-black/50 before:backdrop-blur-sm`}
        >
            <div className="relative w-full max-w-md bg-white rounded-xl shadow-2xl p-6 animate-fadeIn">
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5"
                        fill="currentColor"
                    >
                        <path
                            fillRule="evenodd"
                            d="M6.225 4.811a.75.75 0 0 1 1.06 0L12 9.525l4.716-4.714a.75.75 0 1 1 1.06 1.06L13.06 10.59l4.716 4.715a.75.75 0 1 1-1.06 1.06L12 11.65l-4.715 4.716a.75.75 0 0 1-1.06-1.06L10.94 10.59 6.225 5.87a.75.75 0 0 1 0-1.06Z"
                            clipRule="evenodd"
                        />
                    </svg>
                </button>

                {/* Icon + Title */}
                <div className="text-center">
                    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-100 mb-4">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-7 h-7 text-red-600"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M19 7a1 1 0 0 0-1 1v11.2a1.9 1.9 0 0 1-2 1.8H8a1.9 1.9 0 0 1-2-1.8V8a1 1 0 1 0-2 0v11.2A3.9 3.9 0 0 0 8 23h8a3.9 3.9 0 0 0 4-3.8V8a1 1 0 0 0-1-1Zm1-3h-4V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2ZM10 4V3h4v1Z" />
                            <path d="M11 17V10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0Zm4 0V10a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0Z" />
                        </svg>
                    </div>
                    <h2 className="text-xl font-semibold text-gray-800">{data?.title}</h2>
                    <p className="text-gray-600 mt-2">{data?.summary}</p>
                </div>

                {/* Buttons */}
                <div className="mt-6 flex justify-center gap-4">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="px-5 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-100 transition"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={deleteTheModal}
                        className="px-5 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 active:scale-95 transition"
                    >
                        {isProcessing ? "Processing..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>

    )
}

export default DeletePopup